<template>
  <div class="bind-user-container" v-loading.fullscreen.lock="loading">
    <div class="bind-user-content">
      <div class="bind-type-tab">
        <div :class="['bind-type-item', { active: active === 1 }]" @click.stop="changeTab(1)">
          绑定已有账号
        </div>
        <div :class="['bind-type-item', { active: active === 2 }]" @click.stop="changeTab(2)">
          注册绑定新账号
          <i class="jc-icon-tiaozhuanlianjie new-tab-icon"></i>
        </div>
      </div>
      <div class="bind-user-body">
        <div class="bind-user-body__left">
          <div class="bind-user-profile">
            <div class="avatar">
              <el-avatar :size="64" :src="wxInfo.imgUrl"></el-avatar>
            </div>
            <p class="info">Hi, {{ wxInfo.nickName || '-' }}</p>
            <p class="description"> 登录后完成绑定，即可微信扫码一键登录京东云 </p>
            <div class="bind-img">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="33"
                height="32"
                viewBox="0 0 33 32"
                fill="none"
              >
                <g clip-path="url(#clip0_71_1019)">
                  <path
                    d="M16.4851 0.0625C7.69136 0.0625 0.547607 7.20625 0.547607 16C0.547607 24.7937 7.69136 31.9375 16.4851 31.9375C25.2789 31.9375 32.4226 24.7937 32.4226 16C32.4226 7.20625 25.2757 0.0625 16.4851 0.0625ZM13.5632 20.1969C12.7945 20.1969 12.0226 20.0625 11.332 19.8781C11.2789 19.8781 11.1976 19.825 11.1976 19.825L9.46948 20.8344C9.01948 21.1 8.69761 20.8875 8.83198 20.3844C8.83198 20.3844 9.28198 18.525 9.20386 18.525C7.55698 17.4344 6.78511 16.0281 6.78511 14.1156C6.91948 10.9031 9.73511 8.35 13.5601 8.35C17.0664 8.35 19.9351 10.5281 20.4414 13.3969H20.1226C16.6164 13.3969 13.7476 15.8156 13.7476 18.8156C13.7476 19.3187 13.8007 19.7719 13.9351 20.2219H13.5632V20.1969ZM23.8164 22.6937L24.3195 23.7031C24.5851 24.1562 24.3726 24.3406 23.9476 24.075C23.9476 24.075 22.6726 23.3031 22.6195 23.3844C22.0351 23.5719 20.7601 23.7562 20.1226 23.7562C16.882 23.7562 14.1976 21.525 14.1976 18.7875C14.1976 16.05 16.882 13.8187 20.1226 13.8187C23.3632 13.8187 26.0476 16.0531 26.0476 18.7906C26.0476 20.4094 25.2257 21.7375 23.8164 22.6937ZM11.5164 11.3531C11.2507 11.1937 10.907 11.1937 10.6132 11.3531C10.3476 11.5125 10.1632 11.8031 10.1632 12.1219C10.1632 12.4406 10.3226 12.7344 10.6132 12.8937C10.8789 13.0531 11.2257 13.0531 11.5164 12.8937C11.782 12.7344 11.9695 12.4406 11.9695 12.1219C11.9695 11.8031 11.782 11.5094 11.5164 11.3531ZM16.432 13C16.9382 13 17.3351 12.6 17.3351 12.0969C17.3351 11.7781 17.1757 11.4875 16.8851 11.3281C16.6195 11.1687 16.2726 11.1687 15.982 11.3281C15.6914 11.4875 15.532 11.7781 15.532 12.0969C15.5289 12.6 15.9257 13 16.432 13ZM22.2757 16.1344C21.8507 16.1344 21.507 16.4781 21.507 16.9031C21.507 17.3281 21.8507 17.6719 22.2757 17.6719C22.7007 17.6719 23.0476 17.3281 23.0476 16.9031C23.0476 16.4781 22.7007 16.1344 22.2757 16.1344ZM18.0789 16.1344C17.6539 16.1344 17.3101 16.4781 17.3101 16.9031C17.3101 17.3281 17.6539 17.6719 18.0789 17.6719C18.5039 17.6719 18.8476 17.3281 18.8476 16.9031C18.8476 16.4781 18.5039 16.1344 18.0789 16.1344Z"
                    fill="#08BA06"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_71_1019">
                    <rect width="32" height="32" fill="white" transform="translate(0.485107)" />
                  </clipPath>
                </defs>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
              >
                <g clip-path="url(#clip0_71_1028)">
                  <path
                    d="M15.3029 5.47853L13.0752 7.70873C12.2469 8.53785 11.0729 8.80639 10.0183 8.51919L11.8777 6.66221C11.9053 6.63827 11.9353 6.62001 11.9613 6.59405L14.1891 4.36385C14.804 3.74769 14.804 2.74941 14.1891 2.13323C13.5741 1.51747 12.5766 1.51747 11.9613 2.13323L9.73352 4.36385C9.73352 4.36385 9.73352 4.36385 9.73352 4.36425L9.73187 4.36263L7.8051 6.28656C7.52764 5.23678 7.79742 4.07177 8.61962 3.24833L10.8474 1.01813C12.0781 -0.213401 14.0726 -0.213401 15.3029 1.01813C16.5332 2.24965 16.5332 4.24701 15.3029 5.47853ZM6.14117 11.3335L6.13874 11.3311C5.99351 11.4779 5.79192 11.5696 5.56882 11.5696C5.12668 11.5696 4.76849 11.2118 4.76849 10.7705C4.76849 10.5393 4.86826 10.3324 5.02567 10.1864L10.3205 4.89846C10.4669 4.7419 10.6738 4.64211 10.9054 4.64211C11.3476 4.64211 11.7058 4.99988 11.7058 5.44123C11.7058 5.65947 11.6173 5.85741 11.4753 6.00183L11.4778 6.00427L6.14117 11.3335ZM4.49023 9.59414L2.26246 11.8244C1.64751 12.4401 1.64751 13.4388 2.26246 14.0545C2.87738 14.6703 3.87487 14.6703 4.49023 14.0545L6.71798 11.8244C6.73341 11.8081 6.74395 11.7899 6.75936 11.7737L8.64397 9.89108C8.92548 10.9441 8.65651 12.1132 7.83186 12.9394L5.6041 15.1697C4.37338 16.4016 2.37884 16.4016 1.14856 15.1697C-0.0817454 13.9378 -0.0817454 11.9412 1.14856 10.7089L3.37633 8.47866C4.20221 7.65197 5.37125 7.38303 6.42348 7.66615L4.50602 9.58119C4.50078 9.58603 4.49509 9.58928 4.49023 9.59414Z"
                    fill="black"
                    fill-opacity="0.45"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_71_1028">
                    <rect
                      width="16"
                      height="16"
                      fill="white"
                      transform="translate(0.22583 0.0938721)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <div class="brand-logo">
                <img class="brand-logo-img" :src="jdlogo" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div class="bind-user-body__right">
          <div class="content">
            <div class="login">
              <ul class="login-tab">
                <li
                  class="login-tab--item jd-acount-login"
                  :class="{ selected: activeLogin === 1 }"
                  @click.stop="changeLoginTab(1)"
                >
                  京东账号登录
                </li>
                <li
                  class="login-tab--item"
                  :class="{ selected: activeLogin === 2 }"
                  @click.stop="changeLoginTab(2)"
                >
                  扫码登录
                </li>
              </ul>
              <div class="login-content">
                <iframe
                  v-show="activeLogin === 1"
                  :src="ccoIframeUrl"
                  frameborder="0"
                  style="opacity: 1; border: 0; width: 100%; height: 260px"
                ></iframe>
                <div v-show="activeLogin === 2" class="jd-scan-qrcode">
                  <div class="jd-qrcode-container">
                    <el-qr-code :qrUrl="qrCodeUrl" />
                    <div class="qr-hits" v-if="hasScanQrCode">
                      <template v-if="!scanQrCodeErrorReason">
                        <i class="el-icon-success success-icon" />
                        <div class="tip-content">
                          <p>扫码成功</p>
                          <p>请在手机上确认登录</p>
                        </div>
                      </template>
                      <div v-else class="tip-content">
                        <p class="error-content">{{ scanQrCodeErrorReason }}</p>
                        <el-button type="danger" @click="changeQrUrl">刷新</el-button>
                      </div>
                    </div>
                  </div>
                  <p style="margin-top: 16px">
                    打开
                    <a href="//app.jd.com" target="_blank" class="brand-red">京东 APP</a>
                    扫描二维码
                  </p>
                </div>
              </div>
            </div>
            <div class="agreement">
              <el-checkbox v-model="checkAgreement">
                已阅读并同意
                <a
                  v-for="item in serviceAgreements"
                  :key="item.title"
                  :href="item.url"
                  class="brand-red"
                  >{{ item.title }}</a
                >
              </el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jdlogo from '@/assets/img/jdlogo.png'
import jsonp from 'jsonp'
import Cookies from 'js-cookie'
import { describeWechatInfo } from '@/api/uiam'
import { bindWechat } from '@/api/user'
import { __WX_BIND_USER__ } from '@/utils/enum'
import { useReturnUrl } from '@/hooks'
const qrUrl = '//qr.jdcloud.com'
const jdUrl = '//id.jdcloud.com'

export default {
  data() {
    return {
      jdlogo,
      active: 1,
      isLoop: false,
      checkAgreement: false,
      loading: false,
      activeLogin: 1,
      qrCodeUrl: `${qrUrl}/show?appid=1628&size=147&t=${Date.now()}`,
      timer: null,
      wxInfo: {},
      wxParams: {},
      ccoIframeUrl: `//id.jdcloud.com/common/loginPage?from=jdt_jdcloud_web&regTag=2&pwdTag=2&btnTag=0b6bc653d0c495fb&ReturnUrl=`,
      scanQrCodeErrorReason: '',
      hasScanQrCode: false,
      serviceAgreements: [
        {
          title: '《京东云服务协议》',
          url: 'https://docs.jdcloud.com/cn/platform-agreement/registration-agreement'
        },
        {
          title: '《京东云账号绑定协议》',
          url: 'https://docs.jdcloud.com/cn/platform-agreement/bind-agreement'
        }
      ]
    }
  },
  watch: {
    $route: {
      handler(val) {
        const { name, params, query: { key: publicKey, uid } = {} } = val
        if (name === 'bind-account') {
          this.wxParams = {
            publicKey: atob(publicKey),
            uid: atob(uid),
            ticket: Cookies.get('wechat-key')
          }
          if (params.type === 'wxbind') {
            this.bindJdAccountForWx()
          }
        }
      },
      immediate: true
    },
    checkAgreement(val) {
      if (!val) {
        this.confirmAgreement()
      }
    }
  },
  beforeMount() {
    this.ccoIframeUrl = `${this.ccoIframeUrl}${this.getXwBindUrl()}`
  },
  mounted() {
    this.confirmAgreement()
  },
  created() {
    this.getUserProfile()
    this.timer = setInterval(() => {
      this.isLoop && this.checkScanStatus()
    }, 3000)
  },
  beforeDestroy() {
    this.isLoop = false
    clearInterval(this.timer)
  },
  methods: {
    getXwBindUrl() {
      const { origin, search } = window.location
      const { href } = this.$router.resolve({
        name: 'bind-account',
        params: { type: 'wxbind' }
      })
      return encodeURIComponent(origin + href + search)
    },
    confirmAgreement() {
      if (this.$route.params.type && this.$route.params.type === 'wxbind') {
        this.checkAgreement = true
        return
      }
      const h = this.$createElement
      const serviceArr = []
      this.serviceAgreements.forEach((item) => {
        serviceArr.push(
          h(
            'a',
            {
              class: 'brand-red',
              on: {
                click: () => {
                  window.open(`${item.url}`)
                }
              }
            },
            `${item.title}`
          )
        )
      })
      this.$msgbox({
        title: '请勾选并同意相关协议',
        message: h('p', null, [h('span', null, '已阅读并同意'), ...serviceArr]),
        showCancelButton: true,
        closeOnPressEscape: false,
        closeOnClickModal: false,
        confirmButtonClass: 'confirmButtonClass',
        cancelButtonClass: 'cancelButtonClass',
        showClose: false,
        type: 'warning',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.checkAgreement = true
        })
        .catch(() => {
          const { returnUrl } = useReturnUrl()
          top.location.href = `//login.jdcloud.com?returnUrl=${returnUrl}`
        })
    },
    changeQrUrl() {
      this.hasScanQrCode = false
      this.isLoop = this
      this.qrCodeUrl = `${qrUrl}/show?appid=1628&size=147&_=${Date.now()}`
    },
    async getUserProfile() {
      try {
        const {
          data: { error, result }
        } = await describeWechatInfo({
          ...this.wxParams
        })
        if (error) {
          return this.$message.error(error.message)
        }
        this.wxInfo = result.data || {}
      } catch (e) {
        console.error(e)
      }
    },
    bindJdAccountForWx() {
      const loading = this.$loading({
        lock: true,
        text: '账号绑定中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      bindWechat({
        ...this.wxParams
      })
        .then((response) => {
          const { error, result: { loginName } = {} } = response
          const type = error ? 'fail' : 'success'
          window.sessionStorage.setItem(
            __WX_BIND_USER__,
            JSON.stringify({
              bindFailReason: (error && error.message) || '',
              loginName
            })
          )
          this.$router.replace({
            name: 'bindResult',
            params: { type },
            query: { ...this.$route.query }
          })
        })
        .catch((e) => {
          console.error(e)
        })
        .finally(() => {
          loading.close()
        })
    },
    handleScanFail(message) {
      this.isLoop = false
      this.hasScanQrCode = true
      this.scanQrCodeErrorReason = message
    },
    checkScanStatus() {
      const token = Cookies.get('wlfstk_smdl') || ''
      jsonp(
        `${qrUrl}/check?appid=1628&token=${token}&_=${Date.now()}`,
        { param: 'callback' },
        (err, data) => {
          if (err) {
            console.error(err)
          } else {
            const { code, ticket, msg: errorMessage } = data
            const scanSuccess = () => {
              this.hasScanQrCode = true
              this.scanQrCodeErrorReason = ''
            }

            switch (code) {
              // 已经确认登录，会返回ticket
              case 200:
                scanSuccess()
                ticket && this.submitLogin(ticket)
                break
              // 二维码，未扫描，未过期
              case 201:
                break
              // 二维码，已扫描，未确认登录
              case 202:
                scanSuccess()
                break
              // 二维码已过期，需重新请求二维码
              case 203:
              case 204:
                // 停止轮训，等待用户刷新
                this.handleScanFail('二维码已失效')
                break
              // 取消二维码登录
              case 205:
                this.handleScanFail(errorMessage)
                break
              case 257:
                this.handleScanFail('参数错误')
                break
              default:
                this.handleScanFail('网络异常')
                break
            }
          }
        }
      )
    },
    submitLogin(ticket) {
      this.isLoop = false
      jsonp(
        `${jdUrl}/uc/qrCodeTicketValidation?from=jdc_pc_main&t=${ticket}&_=${Date.now()}`,
        { param: 'callback' },
        (err, data) => {
          if (err) {
            console.error(err)
          } else {
            const { returnCode: code } = data || {}
            if (data) {
              switch (code) {
                // 成功，页面跳转
                case 0:
                  this.setOthersDomainCookie(data)
                  break
                // ticket失效
                case 58:
                case 59:
                  this.handleScanFail('二维码已失效')
                  break
                // -1:网络失败 -2:返回数据包格式错误 -3:返回数据包解包失败 -4:输入参数错误
                case 60:
                case 70:
                  this.handleScanFail('网络异常')
                  break
                case 80:
                  this.handleScanFail('当前环境不支持扫码登录')
                  break
              }
            }
          }
        }
      )
    },
    // https://joyspace.jd.com/h/personal/page/mVGjij1k4n6vWldAUXJW
    setOthersDomainCookie(data) {
      let { url, cnameDomain, loginSsoDomain } = data
      if (!cnameDomain || !loginSsoDomain) {
        top.location.href = decodeURIComponent(this.getXwBindUrl())
        return
      }
      jsonp(`//${cnameDomain}/setCookie?t=sso.jd.com`, { param: 'callback' }, (err) => {
        if (err) {
          console.error(err)
        } else {
          const ssoDomains = loginSsoDomain.split(',') || []
          this.setThirdDomainCookie(ssoDomains, url)
        }
      })
    },
    setThirdDomainCookie(ssoDomains) {
      for (let i = 0; i < ssoDomains.length; i++) {
        if (ssoDomains[i].indexOf('sso.jd.com') >= 0) {
          //sso.jd.com不用处理，jd.com域名登录态自动存在
          continue
        }
        jsonp(`//sso.jd.com/setCookie?t=${ssoDomains[i]}`, { param: 'callback' }, () => {
          top.location.href = decodeURIComponent(this.getXwBindUrl())
        })
      }
    },
    changeTab(code) {
      if (code === 2) {
        this.$router.push({
          name: 'register',
          query: { ...this.$route.query }
        })
      }
    },
    changeLoginTab(code) {
      this.activeLogin = code
      this.hasScanQrCode = false
      if (code === 2) {
        this.isLoop = true
      }
    }
  }
}
</script>

<style lang="less" scoped>
@brand-color: rgba(225, 37, 27, 1);
.brand-red {
  color: @brand-color;
}
.bind-user-container {
  margin: 0 auto;
  width: 1200px;
  margin-top: 16px;
  background-color: #fff;
  .bind-user-content {
    padding: 24px;
    .bind-type-tab {
      display: flex;
      .bind-type-item {
        width: 50%;
        font-size: 24px;
        font-weight: 400;
        line-height: 33px;
        text-align: center;
        border-bottom: 2px solid rgba(0, 0, 0, 0.1);
        padding-bottom: 16px;
        cursor: pointer;
        color: var(--865, rgba(0, 0, 0, 0.65));
        .new-tab-icon {
          font-size: 20px;
        }
        &:hover,
        &.active {
          font-weight: 600;
          color: @brand-color;
          border-bottom-color: @brand-color;
        }
      }
    }
  }
  .bind-user-body {
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
    .bind-user-body__left {
      display: flex;
      justify-content: center;
      width: 50%;
      .bind-user-profile {
        display: flex;
        flex-direction: column;
        align-items: center;
        .avatar {
          margin-bottom: 16px;
        }
        .info {
          color: rgba(0, 0, 0, 0.85);
          text-align: center;
          font-size: 20px;
          font-weight: 600;
        }
        .description {
          margin-top: 8px;
          color: var(--865, rgba(0, 0, 0, 0.65));
          text-align: center;
          font-size: 14px;
          font-weight: 400;
        }
        .bind-img {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 24px;
          gap: 24px;
          .brand-logo {
            width: 32px;
            height: 32px;
            border-radius: 100%;
            background: @brand-color;
            display: flex;
            align-items: center;
            .brand-logo-img {
              height: 18px;
            }
          }
        }
      }
    }
    .line {
      width: 1px;
      height: 398px;
      left: 575px;
      gap: 0;
      background: rgba(0, 0, 0, 0.06);
    }
    .bind-user-body__right {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .content {
        .login {
          width: 356px;
          box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
          display: flex;
          flex-direction: column;
          justify-content: center;
          .login-tab {
            display: flex;
            justify-content: space-between;
            line-height: 32px;
            position: relative;
            border-bottom: 1px solid #e8e8e8;
            font-size: 20px;
            font-weight: 500;
            color: rgba(89, 89, 89, 1);
            padding: 16px 46px 15px 26px;
            .login-tab--item {
              cursor: pointer;
              &:hover {
                color: @brand-color;
              }
              &.selected {
                color: @brand-color;
              }
            }
            .jd-acount-login {
              &::after {
                content: '';
                width: 1px;
                height: 22px;
                position: absolute;
                left: 50%;
                top: 35%;
                background: rgba(0, 0, 0, 0.1);
              }
            }
          }
          .login-content {
            .jd-scan-qrcode {
              display: flex;
              align-items: center;
              flex-direction: column;
              justify-content: center;
              margin-bottom: 22px;
              .jd-qrcode-container {
                padding-top: 24px;
                position: relative;
                .qr-hits {
                  position: absolute;
                  color: white;
                  font-weight: 500;
                  z-index: 1000;
                  top: 24px;
                  width: 200px;
                  height: 200px;
                  border-radius: 8px;
                  background-size: cover;
                  background-image: url('~@/assets/img/jd_qrcode_bg.png');
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  align-items: center;
                  .tip-content {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    line-height: 22px;
                    .error-content {
                      margin-bottom: 8px;
                    }
                  }
                  .success-icon {
                    font-size: 38px;
                    color: #1bca69;
                    margin-bottom: 8px;
                  }
                }
              }
            }
          }
        }
        .agreement {
          margin-top: 16px;
        }
      }
    }
  }
}
</style>
